//import org.apache.commons.lang3.StringUtils;

export class Encoder {

	private   CHARS : string [] =[ "", "", "", "", "", "", "", "", "", " ", " ", "", "", " ",
            "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", " ", "!", "\"",
            "Œ", "", "Ž", "", "", "‘", "’", "“", "”", "•", "–", "—", "˜", "™", "š", "›", "œ", "", "ž", "Ÿ", " ",
			"¡", "¢", "£", "¤", "¥", "¦", "§", "¨", "©", "ª", "«", "¬", "­", "®", "¯", "°", "±", "²", "³", "´", "µ",
			"¶", "·", "¸", "¹", "º", "»", "¼", "½", "¾", "¿", "À", "Á", "Â", "Ã", "Ä", "Å", "Æ", "Ç", "È", "É", "Ê",
			"Ë", "Ì", "Í", "Î", "Ï", "Ð", "Ñ", "Ò", "Ó", "Ô", "Õ", "Ö", "×", "Ø", "Ù", "Ú", "Û", "Ü", "Ý", "Þ", "ß",
			"à", "á", "â", "ã", "ä", "å", "æ", "ç", "è", "é", "ê", "ë", "ì", "í", "î", "ï", "ð", "ñ", "ò", "ó", "ô",
			"#", "$", "%", "&", "\"", "(", ")", "*", "+", ",", "-", ".", "/", "0", "1", "2", "3", "4", "5", "6", "7",
			"8", "9", ":", ";", "<", "=", ">", "?", "@", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L",
			"M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "[", "\\", "]", "^", "_", "`", "a",
			"b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v",
			"w", "x", "y", "z", "{", "|", "}", "~", "", "€", "", "‚", "ƒ", "„", "…", "†", "‡", "ˆ", "‰", "Š", "‹", 
			"õ", "ö", "÷", "ø", "ù", "ú", "û", "ü", "ý", "þ", "ÿ"];

	
	encriptar(texto : String) {
		let cadena :string = "";
		let letra :string = '\0';
		let letraCodigoHexa : string= "";
		let letraInt :number= 0;

		for (var i = 0; i < texto.length; i++) {
			letra = texto.charAt(i);
            letraCodigoHexa = this.getInt(letra).toString(16); 
			cadena = cadena + letraCodigoHexa.toString();
		}

		//texto = cadena.reverse().toString();

//		cadena.setLength(0);
//		for (int i = 0; i < texto.length(); i++) {
//			letra = texto.charAt(i);
//			letraInt = Integer.parseInt(String.valueOf(letra), 16);
//			letraInt += 157;
//			cadena.append(getChar(letraInt));
//		}
        //console.log("cadena : "  , cadena)
		return cadena.toString();

	}

 
	 getChar(letraInt : number) { 
		let index : number = letraInt % 256; 
		return this.CHARS[index];
	}

	 
	 getInt(letraChar : string) {

		for (var i = 0; i < this.CHARS.length; i++)
			if (letraChar === this.CHARS[i])
				return i;

		return -1;
	}

	 /*
	 desencriptar(texto) {
        let cadena :String ;
        
		let letra  = '\0';
		let letraCodigoHexa : string  = "";
		let letraInt : number = 0;

		for (var i = 0; i < texto.length(); i++) {
			letra = texto.charAt(i);
			letraInt = this.getInt(letra) - 157;
			letraCodigoHexa = Integer.toHexString(letraInt);

			cadena = cadena + letraCodigoHexa.toString();
		}


		 texto = cadena.reverse().toString();
 

		return cadena.toString();

	}*/
}



// WEBPACK FOOTER //
// ./src/app/shared/utils/encoder.ts